<template>
  <div class="cWrapper">
    <el-card><el-row class="title-biaoti">商品展示配置</el-row>
      <el-row class="search">
        <el-input type="text" v-model="search.productIds" placeholder="多个商品名称,隔开"></el-input>
        <el-select v-model="search.fuzzyChannels" placeholder="渠道查询方式" clearable>
          <el-option label="精准渠道查询" :value="0"></el-option>
          <el-option label="模糊渠道查询" :value="1"></el-option>
        </el-select>
        <el-select v-model="search.channels" collapse-tags placeholder="请选择渠道"  multiple clearable filterable>
          <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-select v-model="search.fuzzyCountries" placeholder="国家查询方式" clearable>
          <el-option label="精准国家查询" :value="0"></el-option>
          <el-option label="模糊国家查询" :value="1"></el-option>
        </el-select>
        <el-select v-model="search.countries" placeholder="请选择国家" collapse-tags multiple clearable filterable="">
          <el-option v-for="(item, itemIndex) in countryList" v-bind:key="itemIndex + 99" :label="item.country"
            :value="item.countryCode"></el-option>
        </el-select>
        <el-select v-model="search.goodsTypes" placeholder="请选择商品类型" multiple collapse-tags clearable filterable="">
          <el-option v-for="(item, itemIndex) in GoodsType" v-bind:key="itemIndex + 99" :label="item.name"
            :value="item.value"></el-option>
        </el-select>
      </el-row>
      <el-row class="search">
        <el-select v-model="search.useType" placeholder="请选择使用类型" clearable>
          <el-option v-for="(item, itemIndex) in useTypeList" v-bind:key="itemIndex + 99" :label="item"
            :value="itemIndex"></el-option>
        </el-select>
        <el-select v-model="search.valid" placeholder="是否有效" clearable>
          <el-option label="有效" :value="1"></el-option>
          <el-option label="无效" :value="0"></el-option>
        </el-select>
        <el-select v-model="search.showMode" placeholder="是否展示" clearable>
          <el-option label="显示" :value="1"></el-option>
          <el-option label="不显示" :value="0"></el-option>
          <el-option label="审核人员显示" :value="2"></el-option>
        </el-select>

        <el-button type="primary" @click="query" :loading="login">
          查询
        </el-button>
        <el-button type="warning" @click="operate(1)">
          新增
        </el-button>
        <el-button type="danger" @click="clone(1)">
          克隆
        </el-button>
      </el-row>
      <el-row>
        <el-table height="65vh" :data="dataList" style="width: 100%" v-loading="login" border>
          <el-table-column fixed prop="id" label="ID" align="center" sortable>
          </el-table-column>
          <el-table-column fixed prop="productId" label="商品ID" align="center" sortable>
          </el-table-column>
          <el-table-column fixed prop="buyPrice" label="购买价格" align="center" sortable>
          </el-table-column>
          <el-table-column fixed prop="originalPrice" label="原始价格" align="center" sortable>
          </el-table-column>
          <el-table-column prop="buyTitle" label="商品标题" align="center" sortable>
          </el-table-column>
          <el-table-column prop="goodsType" label="商品类型" align="center" sortable>
            <template slot-scope="scope">{{
              GoodsType.filter(item => {
                return item.value === scope.row.goodsType
              })[0].name
            }}</template>
          </el-table-column>
          <el-table-column prop="conditionChannels" label="渠道" align="center" sortable>
          </el-table-column>
          <el-table-column prop="conditionCountries" label="国家" align="center" sortable>
          </el-table-column>
          <el-table-column prop="originalProductId" label="原价商品ID" align="center" sortable>
          </el-table-column>
          <el-table-column prop="buyGolds" label="购买金币" align="center" sortable>
          </el-table-column>
          <el-table-column prop="sendGolds" label="赠送金币" align="center" sortable>
          </el-table-column>
          <!-- <el-table-column prop="middlePayBuyGolds" label="中台赠送金币" align="center" sortable></el-table-column> -->
          <el-table-column prop="middlePaySendGoldsData" label="中台赠送金币新" align="center" sortable>
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="mini" 
                @click="showMiddlePayData(scope.row.middlePaySendGoldsData)"
                :disabled="!scope.row.middlePaySendGoldsData"
              >
                {{ scope.row.middlePaySendGoldsData ? '查看详情' : '暂无数据' }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="rewardId" label="奖励" align="center" sortable>
          </el-table-column>
          <!-- <el-table-column prop="showDate" label="显示日期" align="center">
          </el-table-column> -->
          <!-- <el-table-column prop="showLevel" label="等级标签" align="center" sortable>
            <template slot-scope="scope">{{
              scope.row.showLevel == 0 ? '否' : '是'
            }}</template></el-table-column> -->
          <el-table-column prop="sortId" label="排序" align="center" sortable>
          </el-table-column>
          <!-- <el-table-column prop="bonusDesc" label="优惠名称" align="center" sortable>
          </el-table-column> -->
          <!-- <el-table-column label="充值次数[min-max)" align="center" sortable>
            <template slot-scope="scope">{{ scope.row.minRechargeTimes }}-{{
              scope.row.maxRechargeTimes
            }}</template>
          </el-table-column> -->
          <el-table-column label="图标" align="center" sortable>
            <template slot-scope="scope">
              <el-image v-if="scope.row.icon !== ''" style="width: 100px; height: 100px" :src="scope.row.icon"
                :preview-src-list="[scope.row.icon]">
              </el-image>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="showPriority" label="展示优先级" align="center" sortable>
          </el-table-column> -->
          <el-table-column prop="buyingTips" label="购买tips" align="center" sortable>
          </el-table-column>
          <!-- <el-table-column prop="limitMinutes" label="首页限时（分钟）" align="center" sortable>
          </el-table-column> -->
          <!-- <el-table-column prop="showPriority" label="时间" align="center" sortable>
            <template slot-scope="scope">
              {{ scope.row.startDate }}- {{ scope.row.endDate }}</template>
          </el-table-column> -->
          <el-table-column prop="desc1" label="描述1" align="center" sortable>
          </el-table-column>
          <el-table-column prop="desc2" label="描述2" align="center" sortable>
          </el-table-column>
          <el-table-column prop="useType" label="使用方式" align="center" sortable>
            <template slot-scope="scope">
              <p v-if="scope.row.useType == 0">默认</p>
              <p v-else-if="scope.row.useType == 1">永久订阅</p>
              <p v-else>无</p>
            </template>
          </el-table-column>
          <el-table-column prop="showMode" label="展示" align="center" sortable>
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.showMode == 1">显示</span>
              <span class="red" v-if="scope.row.showMode == 0">不显示</span>
              <span class="yellow" v-if="scope.row.showMode == 2">审核人员显示</span></template>
          </el-table-column>
          <el-table-column prop="ctime" label="创建时间" align="center" sortable>
          </el-table-column>
          <el-table-column prop="mtime" label="修改时间" align="center" sortable>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" align="center" sortable>
          </el-table-column>
          <!-- <el-table-column fixed="right" label="是否可删除" align="center" sortable>
            <template slot-scope="scope">
              <el-tag v-if="!scope.row.remove" type="success">不可删除</el-tag>
              <el-tag v-else type="danger">可删除</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column fixed="right" prop="valid" label="是否有效" align="center" sortable>
            <template slot-scope="scope">
              <span :class="scope.row.valid == 0 ? 'red' : 'green'">{{
                scope.row.valid == 0 ? '无效' : '有效'
              }}</span></template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="operate(2, scope.row)">编辑</el-button>
              <el-button type="warning" size="mini" @click="operate(3, scope.row)">克隆</el-button>
              <el-button type="danger" v-if="scope.row.remove" size="mini" @click="deletes(scope.row.id)">删除</el-button>
            </template>
          </el-table-column></el-table></el-row>
      <el-row class="explaintext">
        <p>
          1、商品id，在某个渠道下同一商品类型保持唯一，不同商品类型配同一商品id奖励需保持一致；商品id为虚拟商品id，配置某个渠道前，需要在支付商品栏目中进行配置。
        </p>
        <p>
          2、奖励id。rewardId=1 1天VIP卡; rewardId 101-120
          匹配卡（1-20张匹配卡）
        </p>
      </el-row>
      <el-row>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
           :page-size="size" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </el-row>
    </el-card>
    <el-drawer :title="type === 2 ? '编辑' : '新增'" size="40%" :visible.sync="drawer" direction="rtl"
      :before-close="handleClose">
      <div class="alist">
        <div class="item">
          <span>商品标题</span><el-input type="text" v-model="goods.buyTitle"></el-input>
        </div>
        <div class="item">
          <span>商品类型</span><el-select v-model="goods.goodsType" placeholder="请选择商品类型" clearable filterable="">
            <el-option v-for="(item, itemIndex) in GoodsType" v-bind:key="itemIndex + 99" :label="item.name"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>国家</span><el-select v-model="goods.conditionCountries" placeholder="请选择国家" collapse-tags multiple
            clearable filterable="">
            <el-option v-for="(item, itemIndex) in countryList" v-bind:key="itemIndex + 99" :label="item.country"
              :value="item.countryCode"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>渠道</span>
          <el-select v-model="goods.conditionChannels" placeholder="请选择渠道" collapse-tags multiple clearable
            filterable="">
            <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>支付渠道</span>
          <el-select v-model="goods.payChannel" placeholder="请选择渠道" clearable
            filterable="" @change="changeView">
            <el-option v-for="(item, itemIndex) in paymentTypes" v-bind:key="itemIndex" :label="item.name"
              :value="item.value"></el-option>
          </el-select>
          <!-- <el-select v-model="goods.supportPayChannels" placeholder="请选择渠道" collapse-tags multiple clearable
            filterable="" @change="changeView">
            <el-option v-for="(item, itemIndex) in paymentTypes" v-bind:key="itemIndex" :label="item.name"
              :value="item.value"></el-option>
          </el-select> -->
        </div>
        <div class="item">
          <span>商品ID</span><el-input type="text" v-model="goods.productId"></el-input>
        </div>
        <div class="item">
          <span>原始商品ID</span><el-input type="text" v-model="goods.originalProductId"></el-input>
        </div>
        <div class="item">
          <span>购买金币</span><el-input type="text" v-model="goods.buyGolds"></el-input>
        </div>
        <div class="item">
          <span>赠送金币</span><el-input type="text" v-model="goods.sendGolds"></el-input>
        </div>
        <div class="item">
          <!-- <span>中台赠送金币</span><el-input type="text" v-model="goods.middlePayBuyGolds"></el-input> -->
          <el-button type="primary" @click="getMiddlePayBuyGolds">配置中台赠送金币</el-button>
        </div>
        <div class="item">
          <span>奖励</span><el-input type="text" v-model="goods.rewardId"></el-input>
        </div>
        <div class="item">
          <span>等级标签</span><el-switch style="display: block" v-model="goods.showLevel" active-color="#13ce66"
            inactive-color="#ff4949" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0">
          </el-switch>
        </div>
        <div class="item">
          <span>排序</span><el-input type="number" v-model="goods.sortId"></el-input>
        </div>
        <div class="item">
          <span>是否有效</span><el-switch style="display: block" v-model="goods.valid" active-color="#13ce66"
            inactive-color="#ff4949" active-text="有效" inactive-text="无效" :active-value="1" :inactive-value="0">
          </el-switch>
        </div>
        <div class="item">
          <span>充值次数[min-max)</span><el-input type="number" v-model="goods.minRechargeTimes"></el-input>--<el-input
            type="number" v-model="goods.maxRechargeTimes"></el-input>
        </div>
        <div class="item">
          <span>限制时长（分钟）</span><el-input type="number" v-model="goods.limitMinutes"></el-input>
        </div>
        <div class="item">
          <span>时间</span><el-date-picker v-model="goods.dataTime" type="datetimerange" align="right" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @input="changeDate">
            <!-- :picker-options="retainedOptions" -->
          </el-date-picker>
        </div>
        <div class="item">
          <span>优惠名称</span><el-input type="text" v-model="goods.bonusDesc"></el-input>
        </div>
        <div class="item">
          <span>是否展示</span>
          <el-select v-model="goods.showMode" placeholder="请选择展示模式">
            <el-option label="不显示" :value="0"></el-option>
            <el-option label="显示" :value="1"></el-option>
            <el-option label="审核人员显示" :value="2"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>购买tips</span><el-input type="text" v-model="goods.buyingTips"></el-input>
        </div>
        <div class="item">
          <span>图标</span><el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false"
            :on-change="changfile" ref="upload">
            <el-image v-if="goods.icon !== ''" style="width: 178px; height: 178px" :src="goods.icon"
              fit="scale-down"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

          <el-input type="text" v-model="goods.icon"></el-input>
        </div>
        <div class="item">
          <span>描述1</span><el-input type="text" v-model="goods.desc1"></el-input>
        </div>
        <div class="item">
          <span>描述2</span><el-input type="text" v-model="goods.desc2"></el-input>
        </div>
        <div class="item">
          <span>使用类型</span><el-select v-model="goods.useType" placeholder="请选择使用类型">
            <el-option v-for="(item, itemIndex) in useTypeList" v-bind:key="itemIndex + 99" :label="item"
              :value="itemIndex"></el-option>
          </el-select>
        </div>
        <div>
          <span>显示日期</span>
          <el-input type="text" v-model="goods.showDate" style="width: 300px;"></el-input>
          <span>配置示例：5/w 每周五</span>
        </div>
      </div>
      <el-row class="buttom">
        <el-button type="primary" @click="modifyGoods()" :loading="dwnload">{{
          type === 1 ? '新增' : '编辑'
        }}</el-button>
      </el-row>
    </el-drawer>
    <el-drawer title="克隆" size="40%" :visible.sync="cloneDrawer" direction="rtl" :before-close="closeClone">
      <div class="alist">
        <div class="item">
          <span>源渠道</span>
          <el-select v-model="cloneData.fromChannel" placeholder="请选择渠道" clearable filterable="">
            <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>目标渠道</span>
          <el-select v-model="cloneData.toChannel" placeholder="请选择渠道" clearable filterable="">
            <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>是否强制导入</span><el-switch style="display: block" v-model="cloneData.forceClone" active-color="#13ce66"
            inactive-color="#ff4949" active-text="是" inactive-text="否" :active-value="true" :inactive-value="false">
          </el-switch>
        </div>
      </div>
      <el-row class="buttom">
        <el-button type="primary" @click="clone(2)">克隆 </el-button>
      </el-row>
    </el-drawer>
    <el-dialog title="配置中台赠送金币" :visible.sync="MiddlePayDialogVisible" width="50%">
      <div v-for="(item, idx) in MiddlePayConfigs" :key="idx"
        style="display:flex;align-items:center;margin-bottom:8px;">
        <el-select v-model="item.payType" placeholder="选择中台方式" style="width:180px;">
          <el-option v-for="pay in payList" :key="pay" :label="pay" :value="pay"
            :disabled="isPayTypeUsed(pay, idx)"></el-option>
        </el-select>
        <el-input v-model.number="item.gold" placeholder="赠送金币数" style="width:180px;margin:0 8px;"></el-input>
        <el-button icon="el-icon-plus" @click="addMiddlePayConfig" v-if="idx === MiddlePayConfigs.length - 1"
          circle></el-button>
        <el-button icon="el-icon-minus" @click="MiddlePayConfigs.splice(idx, 1)" v-if="MiddlePayConfigs.length > 1"
          circle></el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="MiddlePayDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveMiddlePayConfigs">保存</el-button>
      </span>
    </el-dialog>
    
    <!-- 查看中台赠送金币数据弹窗 -->
    <el-dialog title="中台赠送金币详情" :visible.sync="viewMiddlePayDialogVisible" width="40%">
      <el-table :data="viewMiddlePayData" style="width: 100%">
        <el-table-column prop="payType" label="支付方式" align="center"></el-table-column>
        <el-table-column prop="gold" label="赠送金币" align="center"></el-table-column>
      </el-table>
      <div v-if="viewMiddlePayData.length === 0" style="text-align: center; padding: 20px; color: #999;">
        暂无数据
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewMiddlePayDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { UTCTimeToDate } from '@/utils/common'
import { newChannelList, getCountryMore } from '@/utils/normalApi.js'
export default {
  data() {
    return {
      GoodsType: [
        '充值页商品列表',
        '首页限时优惠',
        '首次好评后优惠',
        '首充奖励优惠',
        '第n次购买后的优惠商品',
        '欺骗礼物补偿充值优惠商品',
        '每日转盘奖励优惠',
        '订阅',
        '通话结束页商品'
      ],
      useTypeList: ['默认', '永久订阅', '购买订阅'],
      dataList: [],
      countryList: [],
      channelList: [],
      search: {
        productIds: '',
        goodsTypes: [],
        channels: [],
        countries: [],
        useType: '',
        valid: '',
        showMode: '',
        fuzzyChannels: 0,
        fuzzyCountries: 0
      },
      size: 30,
      page: 1,
      total: 0,
      login: false,
      type: 1,
      paymentTypes: [
        { name: '谷歌内购', value: 0 },
        { name: '谷歌订阅', value: 1 },
        { name: '苹果订阅', value: 9 },
        { name: '苹果内购', value: 10 },
        { name: '华为内购', value: 11 },
        { name: '华为订阅', value: 12 },
        { name: 'vivo内购', value: 13 },
        { name: '中台支付', value: 14 },
        { name: '中台订阅', value: 15 },
        { name: '币商充值', value: 19 },
        { name: 'telegram支付', value: 20 },
        { name: '币商进行三方充值币商钱包', value: 21 },
        { name: 'tap支付', value: 120 },
        { name: '茄子支付', value: 125 }
      ],
      payList: [
        'Default',
        'AIS',
        'Aman',
        'Amex',
        'Apple Pay',
        'Apple Pay-iOS only',
        'ATM Online',
        'AxiataBoost',
        'Bank Transfer',
        'BankTransfer',
        'Benefit',
        'BKMEXPRESS',
        'Boleto',
        'Boost Wallet',
        'CardVirtual',
        'Cash',
        'Celcom',
        'Credit Card',
        'CreditCard',
        'Dana',
        'DepositExpress',
        'Digi',
        'dtac',
        'Easypaisa',
        'Efecty',
        'eNETS',
        'Epay',
        'EWALLET',
        'Fastpay',
        'Fawry',
        'Flip',
        'GCash',
        'Google Pay',
        'Grabpay',
        'GrabPay QR',
        'JazzCash',
        'KakaoPay',
        'Khipu',
        'Knet',
        'LINE Pay',
        'Lottery',
        'Mada',
        'MasterCard',
        'Maxis',
        'Mezza Digital Network',
        'Mobikwik',
        'Mobile Wallets',
        'Nasswallet',
        'Net Bank',
        'Net Banking',
        'NganLuong',
        'One Touch',
        'OPay',
        'OPay Wallet',
        'Orange',
        'OVO',
        'OXXO',
        'PAPARA',
        'PayNow',
        'Paypal',
        'Paytm',
        'PhonePe',
        'PIX',
        'PSE',
        'RAPIPAGO',
        'Razer Gold PIN',
        'SADADVA',
        'Sgate',
        'SPEI',
        'STCPay',
        'Tether USDT',
        'Todito',
        'Touch\'n Go',
        'TrueMoney',
        'U Mobile',
        'Umobile',
        'UPI',
        'USDT',
        'VISA',
        'Vodafone',
        'Wafacash',
        'We',
        'WebPay',
        'Zaincash',
        'ZaloPay'
      ],
      goods: {
        buyTitle: '',
        goodsType: 0,
        showDate: '',
        conditionChannels: '',
        conditionCountries: [],
        conditionChannels: [],
        productId: '',
        originalProductId: '',
        buyGolds: '',
        sendGolds: '',
        middlePayBuyGolds: '',
        middlePaySendGoldsData: '',
        rewardId: '',
        showLevel: 0,
        sortId: '',
        valid: 0,
        minRechargeTimes: '',
        maxRechargeTimes: '',
        limitMinutes: '',
        dataTime: [],
        bonusDesc: '',
        showMode: 0,
        buyingTips: '',
        icon: '',
        desc1: '',
        desc2: '',
        id: '',
        useType: 0
      },
      drawer: false,
      dwnload: false,
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      cloneDrawer: false,
      cloneData: {
        fromChannel: '',
        toChannel: '',
        forceClone: false
      },
      MiddlePayDialogVisible: false,
      MiddlePayConfigs: [
        { payType: '', gold: 0 }
      ],
      // 查看中台赠送金币数据的弹窗
      viewMiddlePayDialogVisible: false,
      viewMiddlePayData: []
    }
  },
  async created() {
    this._getCountry()
    this.channelList = await newChannelList()
    // this.query()
    this.getGoodsType()
  },
  methods: {
    async deletes(id) {
      this.$confirm('确定删除该商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await this.$axios.get(
          this.$store.getters.path.config_delete_goods +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token +
          "&id=" +
          id
        );
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success('操作成功')
        this.query()
      })
    },
    getMiddlePayBuyGolds() {
      // 解析已有配置
      if (this.goods.middlePaySendGoldsData && this.goods.middlePaySendGoldsData.length > 2) {
        try {
          console.log(this.goods.middlePaySendGoldsData);
          const obj = JSON.parse(this.goods.middlePaySendGoldsData);
          this.MiddlePayConfigs = Object.entries(obj).map(([payType, gold]) => ({ payType, gold }));
        } catch {
          this.MiddlePayConfigs = [{ payType: 'Default', gold: 0 }];
        }
      } else {
        this.MiddlePayConfigs = [{ payType: 'Default', gold: 0 }];
      }
      console.log("---");
      console.log(this.MiddlePayConfigs);
      this.MiddlePayDialogVisible = true;
    },
    changeDate(val) {
      console.log(val);
      this.$forceUpdate()
    },
    handleSizeChange(val) {
      this.size = val
      this.query()
    },
    handleCurrentChange(val) {
      this.page = val
      this.query()
    },
    async query() {
      this.login = true
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_goods_query +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token+
        '&page='+this.page+
        '&size='+this.size,
        {
          productIds:
            this.search.productIds !== ''
              ? this.search.productIds.split(',')
              : [],
          goodsTypes: this.search.goodsTypes,
          channels: this.search.channels,
          countries: this.search.countries,
          useType: this.search.useType,
          valid: this.search.valid,
          showMode: this.search.showMode,
          fuzzyChannels: this.search.fuzzyChannels,
          fuzzyCountries: this.search.fuzzyCountries
        }
      )
      this.login = false
      if (res.code != 0) return this.$message(res.msg)
      this.dataList = res.data.data
      this.total = res.data.total
      this.dataList.map(item => {
        if (item.ctime !== 0)
          item.ctime = UTCTimeToDate(item.ctime, 'yyyy-MM-dd HH:mm:ss')
        if (item.mtime !== 0)
          item.mtime = UTCTimeToDate(item.mtime, 'yyyy-MM-dd HH:mm:ss')
      })
    },
    async getGoodsType() {
      this.login = true
      const { data: res } = await this.$axios(
        this.$store.getters.path.config_goods_type +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        {}
      )
      this.login = false
      if (res.code != 0) return this.$message(res.msg)
      this.GoodsType = res.data
    },
    async _getCountry() {
      const res = await getCountryMore()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    operate(type, obj) {
      this.type = type
      if (type === 2 || type === 3) {
        this.goods = { ...obj }
        this.goods.conditionCountries =
          this.goods.conditionCountries !== ''
            ? this.goods.conditionCountries.split(',')
            : []
        this.goods.conditionChannels =
          this.goods.conditionChannels !== ''
            ? this.goods.conditionChannels.split(',')
            : []
        if (this.goods.startDate && this.goods.startDate !== '')
          this.goods.dataTime = [this.goods.startDate, this.goods.endDate]
      }
      if (type === 3) this.goods.id = ''
      this.drawer = true
    },
    changeView(){
      this.$forceUpdate()

    },
    async modifyGoods() {
      if (this.goods.minRechargeTimes > this.goods.maxRechargeTimes)
        return this.$message('最大充值次数不能小于最小充值次数')
      this.dwnload = true
      console.log(this.goods.dataTime);

      let data = {
        buyTitle: this.goods.buyTitle,
        goodsType: this.goods.goodsType,
        conditionCountries:
          this.goods.conditionCountries !== ''
            ? this.goods.conditionCountries.join(',')
            : '',
        conditionChannels:
          this.goods.conditionChannels !== ''
            ? this.goods.conditionChannels.join(',')
            : '',
        productId: this.goods.productId,
        originalProductId: this.goods.originalProductId,
        buyGolds: this.goods.buyGolds,
        sendGolds: this.goods.sendGolds,
        middlePayBuyGolds: this.goods.middlePayBuyGolds,
        middlePaySendGoldsData: this.goods.middlePaySendGoldsData,
        rewardId: this.goods.rewardId,
        showLevel: this.goods.showLevel,
        sortId: this.goods.sortId,
        valid: this.goods.valid,
        bonusDesc: this.goods.bonusDesc,
        minRechargeTimes: this.goods.minRechargeTimes,
        maxRechargeTimes: this.goods.maxRechargeTimes,
        limitMinutes: this.goods.limitMinutes,
        showMode: this.goods.showMode,
        buyingTips: this.goods.buyingTips,
        icon: this.goods.icon,
        desc1: this.goods.desc1,
        desc2: this.goods.desc2,
        showDate: this.goods.showDate,
        payChannel: this.goods.payChannel,
        startDate:
          this.goods.dataTime ? this.goods.dataTime[0] : null,
        endDate:
          this.goods.dataTime ? this.goods.dataTime[1] : null,
        useType: this.goods.useType
      }
      if (this.type === 2) {
        data.id = this.goods.id
      }
      console.log("-=-=-=");
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_update_goods +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        { data: data }
      )
      this.dwnload = false
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success('操作成功')
      this.query()
      this.handleClose()
    },
    handleClose() {
      this.goods = {
        buyTitle: '',
        goodsTypes: 0,
        conditionCountries: [],
        conditionChannels: [],
        productId: '',
        originalProductId: '',
        buyGolds: '',
        sendGolds: '',
        middlePayBuyGolds: '',
        rewardId: '',
        showLevel: 0,
        sortId: '',
        valid: 0,
        minRechargeTimes: '',
        maxRechargeTimes: '',
        limitMinutes: '',
        dataTime: [],
        bonusDesc: '',
        showMode: 0,
        buyingTips: '',
        icon: '',
        desc1: '',
        desc2: '',
        id: '',
        useType: 0,
        showDate: ''
      }
      this.drawer = false
    },
    async changfile(file) {
      this.dwnload = true
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', 'config/goods')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formdata
      )
      this.dwnload = false
      if (res.code !== 0) {
        this.$refs.upload.clearFiles()
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      this.goods.icon = res.data
    },
    async clone(type) {
      if (type == 1) {
        this.cloneDrawer = true
      } else if (type == 2) {
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.config_clone_goods +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
          { ...this.cloneData }
        )
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success('操作成功')
        this.query()
        this.closeClone()
      }
    },
    closeClone() {
      this.cloneData = {
        fromChannel: '',
        toChannel: '',
        forceClone: false
      }
      this.cloneDrawer = false
    },
    saveMiddlePayConfigs() {
      // 保存所有项，包括空值、未填写或0的值
      const obj = {};
      this.MiddlePayConfigs.forEach(item => {
        if (item.payType) {
          obj[item.payType] = item.gold ? +item.gold : 0;
        }
      });
      this.goods.middlePaySendGoldsData = JSON.stringify(obj);
      console.log(this.goods.middlePaySendGoldsData);
      this.MiddlePayDialogVisible = false;
    },
    isPayTypeUsed(payType, currentIndex) {
      return this.MiddlePayConfigs.some((item, index) =>
        index !== currentIndex && item.payType === payType
      );
    },
    addMiddlePayConfig() {
      this.MiddlePayConfigs.push({ payType: '', gold: 0 });
    },
    
    // 显示中台赠送金币数据详情
    showMiddlePayData(dataString) {
      if (!dataString) {
        this.viewMiddlePayData = [
          {
            payType: 'Default',
            gold: 0
          }
        ];
        this.viewMiddlePayDialogVisible = true;
        return;
      }
      
      try {
        const obj = JSON.parse(dataString);
        this.viewMiddlePayData = Object.entries(obj).map(([payType, gold]) => ({
          payType,
          gold: parseInt(gold) || 0
        }));
      } catch (error) {
        console.error('解析中台赠送金币数据失败:', error);
        this.viewMiddlePayData = [
        {
            payType: 'Default',
            gold: 0
          }
        ];
        this.$message.error('数据格式错误，无法解析');
      }
      
      this.viewMiddlePayDialogVisible = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.search {
  display: flex;

  >* {
    margin: 0 5px;
  }

  .el-input {
    width: 300px;
  }
}

.alist {
  padding: 10px;

  .item {
    display: flex;
    align-items: center;
    padding: 5px 0;

    span {
      white-space: nowrap;
      padding: 0 5px;
    }
  }
}

.buttom {
  display: flex;
  justify-content: center;
}

.cell {
  display: flex;

  >* {
    margin: 2px;
  }
}

.red {
  color: red;
}

.green {
  color: green;
}

.yellow {
  color: yellow;
}

.explaintext {
  font-size: 12px;
  line-height: 16px;
  color: #555;
}
</style>
